import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickLoadJobsiteSalesAction } from '../../actions/one-click-jobsites.actions';
import { State } from '../../reducers';

@Injectable()
export class OneClickLoadSalesArea implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store.dispatch(new OneClickLoadJobsiteSalesAction());
  }
}
